import { Modal } from 'react-bootstrap';
import AddBookingForm from '../../common/AddBookingForm';
import '../../common/AddBookingModal.css';
export default function AddBookingModal({ show, onClose, initialValues }) {
  const handleSuccess = () => {
    window.dispatchEvent(new CustomEvent('calendar-booking-added'));

    // close modal
    onClose();
  };
  return (
    <Modal show={show} onHide={onClose} size="xl" centered backdrop="static" className="add-booking-modal">
      <Modal.Header closeButton>
        <Modal.Title>Add New Booking</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <AddBookingForm initialValues={initialValues} isModal onSuccess={handleSuccess} onCancel={onClose} />
      </Modal.Body>
    </Modal>
  );
}
